import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import jsPDF from 'jspdf';
import Select from "react-select";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";

function BirthCert() {
    const [ldata, setLdata] = useState(null);
    const [image, setImage] = useState('');
    const [isAdmin, setIsAdmin] = useState('');
    const [watermarkImage, setWatermarkImage] = useState('');
    const [footerImage, setFooterImage] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);

    const [formData, setFormData] = useState({
        l1: [],
        doc: [],
        page_no: 0,
        cert_id: '',
        cert_dc_number: '',
        cert_dod: '',
        cert_type: 'birth',
        cert_ipd_number: '',
        cert_patient_name: '',
        cert_guardien: '',
        cert_address: '',
        cert_city: '',
        cert_state: '',
        cert_pincode: '',
        cert_doctor: '',
        cert_mobile: '',
        cert_issued: '',
        cert_case: '',
        cert_attandant: '',
        cert_user: '',
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        cert_child_name: '',
        cert_child_weight_kg: '',
        cert_child_weight_gm: '',
        cert_born_in: '',
        isAlert: false,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if ((name + "").localeCompare("search_key") == 0) {
            initData();
        }
    };

    // Helper: build combined weight string like "2 KG 300 gm" or "500 gm"
    const buildWeightString = (kg, gm) => {
        const kgVal = parseInt(kg) || 0;
        const gmVal = parseInt(gm) || 0;
        if (kgVal > 0 && gmVal > 0) return `${kgVal} KG ${gmVal} gm`;
        if (kgVal > 0) return `${kgVal} KG`;
        if (gmVal > 0) return `${gmVal} gm`;
        return "";
    };

    // Format date only → DD-MM-YYYY
    const formatDate = (dateString) => {
        if (!dateString) return "";
        try {
            const date = new Date(dateString);
            return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
        } catch (e) { return dateString; }
    };

    // Format datetime → DD-MM-YYYY HH:MM AM/PM
    const formatDateTime = (dtString) => {
        if (!dtString) return "";
        try {
            const date = new Date(dtString);
            const dd   = String(date.getDate()).padStart(2, '0');
            const mm   = String(date.getMonth() + 1).padStart(2, '0');
            const yyyy = date.getFullYear();
            let   hours = date.getHours();
            const mins  = String(date.getMinutes()).padStart(2, '0');
            const ampm  = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            return `${dd}-${mm}-${yyyy} ${String(hours).padStart(2, '0')}:${mins} ${ampm}`;
        } catch (e) { return dtString; }
    };

    // Get current datetime in datetime-local input format (YYYY-MM-DDTHH:MM)
    const getNowLocal = () =>
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString().slice(0, 16);

    const resetForm = () => {
        const random10Digit = Math.floor(1000000000 + Math.random() * 9000000000);
        const today = new Date().toISOString().split("T")[0];
        setFormData(prev => ({
            ...prev,
            cert_id: '',
            cert_dc_number: random10Digit.toString(),
            cert_dod: today,
            cert_ipd_number: '',
            cert_patient_name: '',
            cert_child_name: '',
            cert_guardien: '',
            cert_address: '',
            cert_city: '',
            cert_state: '',
            cert_pincode: '',
            cert_doctor: '',
            cert_mobile: '',
            cert_issued: getNowLocal(),   // reset to current time
            cert_case: '',
            cert_attandant: '',
            cert_user: '',
            cert_child_weight_kg: '',
            cert_child_weight_gm: '',
            cert_born_in: '',
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const fd = new FormData();
        fd.append('cert_id', formData.cert_id);
        fd.append('cert_type', formData.cert_type);
        fd.append('cert_dc_number', formData.cert_dc_number);
        fd.append('cert_dod', formData.cert_dod);
        fd.append('cert_ipd_number', formData.cert_ipd_number);
        fd.append('cert_patient_name', formData.cert_patient_name);
        fd.append('cert_child_name', formData.cert_child_name);
        fd.append('cert_guardien', formData.cert_guardien);
        fd.append('cert_address', formData.cert_address);
        fd.append('cert_city', formData.cert_city);
        fd.append('cert_state', formData.cert_state);
        fd.append('cert_pincode', formData.cert_pincode);
        fd.append('cert_doctor', formData.cert_doctor);
        fd.append('cert_mobile', formData.cert_mobile);
        fd.append('cert_issued', formData.cert_issued);
        fd.append('cert_case', formData.cert_case);
        fd.append('cert_attandant', formData.cert_attandant);
        fd.append('cert_user', ldata.user_id);
        fd.append('cert_child_weight', buildWeightString(formData.cert_child_weight_kg, formData.cert_child_weight_gm));
        fd.append('cert_born_in', formData.cert_born_in);

        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.addCertUrl, fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.data.status) {
                toast.success(response.data.success || "Saved successfully");
                resetForm();
                initData();
            } else {
                toast.error(response.data.success || "Something went wrong");
            }
        } catch (error) {
            toast.error("Failed to save certificate");
        }
    };

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        const userData = JSON.parse(sessionStorage.getItem("ldata"));
        const roleId = userData?.role_id;
        setIsAdmin(roleId === 1 || roleId === "1");
        if (storedData) {
            const fd = new FormData();
            fd.append('page_no', formData.page_no + "");
            fd.append('search_key', formData.search_key + "");
            fd.append('cert_type', formData.cert_type + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCertListUrl, fd, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                if (response.data.status) {
                    const records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({ ...prev, l1: records }));
                    }
                }
            } catch (error) { }
        }
    };

    const initData2 = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const fd = new FormData();
            fd.append('type', "doctor");
            fd.append('user_cre_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                if (response.data.status) {
                    const records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({ ...prev, doc: records }));
                    }
                }
            } catch (error) { }
        }
    };

    // ── EDIT ────────────────────────────────────────────────────────────────
    const setEditItem = (tmp) => {
        let kgPart = '';
        let gmPart = '';
        if (tmp.cert_child_weight) {
            const kgMatch = tmp.cert_child_weight.match(/(\d+)\s*KG/i);
            const gmMatch = tmp.cert_child_weight.match(/(\d+)\s*gm/i);
            if (kgMatch) kgPart = kgMatch[1];
            if (gmMatch) gmPart = gmMatch[1];
        }
        // Convert stored datetime to datetime-local input format
        let issuedLocal = '';
        if (tmp.cert_issued) {
            try {
                issuedLocal = new Date(
                    new Date(tmp.cert_issued).getTime() -
                    new Date().getTimezoneOffset() * 60000
                ).toISOString().slice(0, 16);
            } catch (e) { issuedLocal = tmp.cert_issued; }
        }
        setFormData(prev => ({
            ...prev,
            cert_id: tmp.cert_id,
            cert_type: tmp.cert_type,
            cert_dc_number: tmp.cert_dc_number,
            cert_dod: tmp.cert_dod,
            cert_ipd_number: tmp.cert_ipd_number,
            cert_patient_name: tmp.cert_patient_name,
            cert_child_name: tmp.cert_child_name || '',
            cert_guardien: tmp.cert_guardien,
            cert_address: tmp.cert_address,
            cert_city: tmp.cert_city,
            cert_state: tmp.cert_state,
            cert_pincode: tmp.cert_pincode,
            cert_doctor: tmp.cert_doctor,
            cert_mobile: tmp.cert_mobile,
            cert_issued: issuedLocal,
            cert_case: tmp.cert_case,
            cert_attandant: tmp.cert_attandant,
            cert_user: tmp.cert_user,
            cert_child_weight_kg: kgPart,
            cert_child_weight_gm: gmPart,
            cert_born_in: tmp.cert_born_in || '',
        }));
        window.scrollTo({ top: 0, behavior: 'smooth' });
        toast.info("Record loaded for editing");
    };

    // ── DELETE ──────────────────────────────────────────────────────────────
    const confirmDelete = (row) => {
        setDeleteTarget(row);
        setShowDeleteModal(true);
    };

    const delItem = async () => {
        if (!deleteTarget) return;
        const fd = new FormData();
        fd.append('cert_id', deleteTarget.cert_id + "");
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.delCertUrl, fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.data.status) {
                toast.success("Certificate deleted successfully");
                initData();
            } else {
                toast.error("Failed to delete");
            }
        } catch (error) {
            toast.error("Error deleting certificate");
        }
        setShowDeleteModal(false);
        setDeleteTarget(null);
    };

    useEffect(() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
            initData2();
        }
        return () => { };
    }, []);

    useEffect(() => {
        const today = new Date().toISOString().split("T")[0];
        const random10Digit = Math.floor(1000000000 + Math.random() * 9000000000);
        setFormData(prev => ({
            ...prev,
            cert_dod: today,
            cert_dc_number: random10Digit.toString(),
            cert_issued: getNowLocal(),   // pre-fill issued with current date & time
        }));
    }, []);

    const searchUserNow = async () => {
        const uhid = (formData.cert_ipd_number || "").trim();
        if (uhid.length <= 7) { toast.error("Please enter a valid UHID"); return; }
        try {
            const fd = new FormData();
            fd.append("lab_reg_uhid", uhid);
            const response = await axios.post(AppConst.BASE_URL + AppConst.searchUhidUrlCall, fd, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            if (response.data.status) {
                const users = response.data.records;
                if (users && users.length > 0) {
                    const patient = users[0];
                    setFormData(prev => ({
                        ...prev,
                        cert_patient_name: patient.lab_reg_name || "",
                        cert_guardien: patient.lab_guardian_name || "",
                        cert_gender: patient.lab_reg_gender || "Male",
                        cert_address: patient.lab_reg_address || "",
                        cert_city: patient.lab_reg_city || "",
                        cert_state: patient.lab_reg_state || "",
                        cert_mobile: patient.lab_reg_mobile || patient.ipd_patient_mobile || "",
                        cert_doctor: patient.lab_reg_referral || patient.ipd_refer_doctor || "",
                        cert_ipd_number: patient.lab_reg_uhid || "",
                    }));
                    toast.success("Patient details loaded");
                } else {
                    toast.error("No patient found with this UHID");
                }
            } else {
                toast.error(response.data.message || "No patient found");
            }
        } catch (error) {
            toast.error("Error fetching patient details");
        }
    };

    function getDoctorNameById(id) {
        const doctor = formData.doc.find(doc => doc.user_id === String(id));
        return doctor ? doctor.fname : "—";
    }

    const fetchConfigData = async () => {
        try {
            const res = await axios.post(`${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`);
            if (res.data.status) {
                const data = res.data;
                setImage(data.header_logo);
                setWatermarkImage(data.logo || '');
                setFooterImage(data.footer_logo || '');
            }
        } catch (err) {
            console.error("Error fetching config:", err);
        }
    };

    useEffect(() => { fetchConfigData(); }, [formData]);

    const imageUrlToBase64 = async (url) => {
        if (!url) return null;
        try {
            const response = await fetch(url, { cache: 'no-cache' });
            if (!response.ok) return null;
            const blob = await response.blob();
            if (!blob.type.startsWith('image/')) return null;
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) { return null; }
    };

    const generateBirthCertificatePDF = async (certData) => {
        if (!certData) { toast.error("Certificate data is missing!"); return; }
        const doc = new jsPDF("p", "mm", "a4");
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const leftMargin = 20;
        const rightMargin = pageWidth - 20;
        let y = 30;

        doc.setDrawColor(0);
        doc.setLineWidth(1.2);
        doc.rect(10, 10, pageWidth - 20, pageHeight - 20, "S");

        if (image) {
            const headerImgBase64 = await imageUrlToBase64(image);
            if (headerImgBase64) doc.addImage(headerImgBase64, "PNG", 10, 10, pageWidth - 20, 25);
        }
        y = 50;

        doc.setFontSize(20);
        doc.setFont("helvetica", "bold");
        doc.text("BIRTH CERTIFICATE", pageWidth / 2, y, { align: "center" });
        y += 20;

        doc.setFontSize(12);
        doc.setFont("helvetica", "italic");
        doc.text(`Certificate No: ${certData.cert_id || "_____________"}`, leftMargin, y);
        y += 15;

        doc.setFontSize(13);
        doc.setFont("helvetica", "normal");

        let weightDisplay = "";
        if (certData.cert_child_weight) {
            weightDisplay = certData.cert_child_weight;
        } else {
            weightDisplay = buildWeightString(certData.cert_child_weight_kg, certData.cert_child_weight_gm);
        }

        const details = [
            ["Child Name",    certData.cert_child_name   || "_____________"],
            ["Patient Name",  certData.cert_patient_name || "_____________"],
            ["Guardian",      certData.cert_guardien      || "_____________"],
            ["Date of Birth", certData.cert_dod ? formatDate(certData.cert_dod) : "____/____/______"],
            ["Child Weight",  weightDisplay               || "_____________"],
            ["Born In",       certData.cert_born_in       || "_____________"],
            ["Address",       `${certData.cert_address}, ${certData.cert_city}, ${certData.cert_state} - ${certData.cert_pincode}`],
            // ✅ Fixed: was certData.issued — now cert_issued with full date & time
            ["Issued On",     certData.cert_issued ? formatDateTime(certData.cert_issued) : "_____________"],
        ];

        details.forEach(([label, value]) => {
            doc.setFont("helvetica", "bold");
            doc.text(`${label}:`, leftMargin, y);
            doc.setFont("helvetica", "normal");
            doc.text(value, leftMargin + 60, y);
            y += 12;
        });

        y += 15;
        doc.setFont("helvetica", "italic");
        doc.setFontSize(12);
        const declarationText = `
This is to certify that ${certData.cert_child_name},
child of ${certData.cert_patient_name},
was born on ${formatDate(certData.cert_dod)}${weightDisplay ? `, weight ${weightDisplay}` : ""}${certData.cert_born_in ? `, at ${certData.cert_born_in}` : ""}.

This certificate is issued for official purposes.
`;
        const splitDeclaration = doc.splitTextToSize(declarationText, pageWidth - 60);
        splitDeclaration.forEach((line) => {
            doc.text(line, pageWidth / 2, y, { align: "center" });
            y += 8;
        });
        y += 5;

        const signatureBlockX = pageWidth / 2 + 10;
        doc.line(signatureBlockX, y, rightMargin, y);
        y += 10;
        doc.setFont("helvetica", "bold");
        doc.text("Registrar / Doctor", signatureBlockX, y);
        y += 8;
        doc.setFont("helvetica", "normal");
        doc.text(` ${getDoctorNameById(certData.cert_doctor) || "________________"}`, signatureBlockX, y);
        y += 8;
        doc.text("Official Seal / Stamp", signatureBlockX, y);

       
        window.open(doc.output("bloburl"), "_blank");
    };

    // ── DataTable columns ──────────────────────────────────────────────────
    const columns = [
        {
            name: "Sr.",
            cell: (row, index) => index + 1,
            width: "55px"
        },
        {
            name: "Child Name",
            selector: row => row.cert_child_name,
            wrap: true,
        },
        {
            name: "Patient",
            selector: row => row.cert_patient_name,
            wrap: true,
        },
        {
            name: "Weight",
            selector: row => row.cert_child_weight || "—",
            width: "110px"
        },
        {
            name: "Born In",
            selector: row => row.cert_born_in || "—",
            wrap: true,
        },
        {
            // ✅ Issued date+time shown in list
            name: "Issued On",
            cell: row => formatDateTime(row.cert_issued) || "—",
            wrap: true,
            width: "155px",
        },
        {
            name: "Cert No.",
            selector: row => row.cert_id,
            width: "85px"
        },
        {
            name: "Doctor",
            cell: row => getDoctorNameById(row.cert_doctor),
            wrap: true,
        },
        {
            name: "Actions",
            width: "160px",
            cell: row => (
                <div style={{ display: 'flex', gap: '5px' }}>
                    <button className="btn btn-sm btn-dark" title="Print Certificate" onClick={() => generateBirthCertificatePDF(row)}>
                        <i className="ri-printer-line"></i>
                    </button>
                    <button className="btn btn-sm btn-warning" title="Edit Record" onClick={() => setEditItem(row)}>
                        <i className="ri-edit-line"></i>
                    </button>
                    <button className="btn btn-sm btn-danger" title="Delete Record" onClick={() => confirmDelete(row)}>
                        <i className="ri-delete-bin-line"></i>
                    </button>
                </div>
            )
        }
    ];

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xxl-12">

                        {/* ── Form Card ── */}
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h5>
                                        {formData.cert_id ? (
                                            <>
                                                <i className="ri-edit-line me-1 text-warning"></i>
                                                Edit Birth Certificate
                                                <span className="badge bg-warning text-dark ms-2">#{formData.cert_id}</span>
                                            </>
                                        ) : (
                                            "Birth Certificate"
                                        )}
                                    </h5>
                                    {formData.cert_id && (
                                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={resetForm}>
                                            <i className="ri-add-line me-1"></i>New Record
                                        </button>
                                    )}
                                </div>
                                <br />
                                <div className="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row g-3">

                                            <div className="col-md-4">
                                                <label className="form-label">DOD</label>
                                                <input name="cert_dod" onChange={handleChange} value={formData.cert_dod} className="form-control" placeholder="Enter DOD" type="text" required />
                                            </div>

                                            <div className="col-md-2">
                                                <label className="form-label">UHID Number</label>
                                                <input name="cert_ipd_number" onChange={handleChange} value={formData.cert_ipd_number} className="form-control" placeholder="Enter UHID" type="text" required />
                                            </div>
                                            <div className="col-md-2 d-flex align-items-end">
                                                <button onClick={searchUserNow} type="button" className="btn btn-success w-100">
                                                    <i className="ri-search-line align-bottom me-1"></i>Search
                                                </button>
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label">Patient Name</label>
                                                <input name="cert_patient_name" onChange={handleChange} value={formData.cert_patient_name} className="form-control" placeholder="Enter Patient Name" type="text" required />
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label">Child Name</label>
                                                <input name="cert_child_name" value={formData.cert_child_name} onChange={handleChange} className="form-control" placeholder="Enter Child Name" type="text" required />
                                            </div>

                                            {/* Child Weight */}
                                            <div className="col-md-4">
                                                <label className="form-label">Child Weight</label>
                                                <div className="d-flex gap-2">
                                                    <div className="input-group" style={{ flex: 1 }}>
                                                        <input name="cert_child_weight_kg" value={formData.cert_child_weight_kg} onChange={handleChange} className="form-control" placeholder="0" type="number" min="0" />
                                                        <span className="input-group-text">KG</span>
                                                    </div>
                                                    <div className="input-group" style={{ flex: 1 }}>
                                                        <input name="cert_child_weight_gm" value={formData.cert_child_weight_gm} onChange={handleChange} className="form-control" placeholder="0" type="number" min="0" max="999" />
                                                        <span className="input-group-text">gm</span>
                                                    </div>
                                                </div>
                                                {(formData.cert_child_weight_kg || formData.cert_child_weight_gm) && (
                                                    <small className="text-muted mt-1 d-block">
                                                        Weight: <strong>{buildWeightString(formData.cert_child_weight_kg, formData.cert_child_weight_gm)}</strong>
                                                    </small>
                                                )}
                                            </div>

                                            {/* Born In */}
                                            <div className="col-md-4">
                                                <label className="form-label">Born In</label>
                                                <input name="cert_born_in" value={formData.cert_born_in} onChange={handleChange} className="form-control" placeholder="e.g. City Hospital, Ward No. 5" type="text" />
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label">Guardian</label>
                                                <input name="cert_guardien" onChange={handleChange} value={formData.cert_guardien} className="form-control" placeholder="Enter Guardian" type="text" required />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Address</label>
                                                <input name="cert_address" onChange={handleChange} value={formData.cert_address} className="form-control" placeholder="Enter Address" type="text" required />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">City</label>
                                                <input name="cert_city" onChange={handleChange} value={formData.cert_city} className="form-control" placeholder="Enter City" type="text" required />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">State</label>
                                                <input name="cert_state" onChange={handleChange} value={formData.cert_state} className="form-control" placeholder="Enter State" type="text" required />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Pincode</label>
                                                <input name="cert_pincode" onChange={handleChange} value={formData.cert_pincode} className="form-control" placeholder="Enter Pincode" type="text" required />
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label">Doctor</label>
                                                <Select
                                                    options={formData.doc.map(d => ({ value: d.user_id, label: d.fname }))}
                                                    value={formData.doc.map(d => ({ value: d.user_id, label: d.fname })).find(o => o.value == formData.cert_doctor) || null}
                                                    onChange={(selected) => setFormData(prev => ({ ...prev, cert_doctor: selected ? selected.value : "" }))}
                                                    placeholder="Select Doctor"
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label className="form-label">Mobile Number</label>
                                                <input name="cert_mobile" onChange={handleChange} value={formData.cert_mobile} className="form-control" placeholder="Enter Mobile Number" type="number" required />
                                            </div>

                                            {/* ── Issued Date & Time ── */}
                                            <div className="col-md-4">
                                                <label className="form-label">Issued Date &amp; Time</label>
                                                <input
                                                    name="cert_issued"
                                                    onChange={handleChange}
                                                    value={formData.cert_issued}
                                                    className="form-control"
                                                    type="datetime-local"
                                                    required
                                                />
                                                {/* Human-readable preview below the input */}
                                                {formData.cert_issued && (
                                                    <small className="text-muted mt-1 d-block">
                                                        <i className="ri-time-line me-1"></i>
                                                        {formatDateTime(formData.cert_issued)}
                                                    </small>
                                                )}
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Case</label>
                                                <textarea name="cert_case" onChange={handleChange} value={formData.cert_case} className="form-control" placeholder="Enter Case" required></textarea>
                                            </div>

                                            <div className="col-lg-12">
                                                <div className="text-end">
                                                    <button type="submit" className={`btn ${formData.cert_id ? 'btn-warning' : 'btn-primary'}`}>
                                                        <i className={`ri-${formData.cert_id ? 'save' : 'add'}-line me-1`}></i>
                                                        {formData.cert_id ? 'Update' : 'Save'}
                                                    </button>
                                                    &nbsp;&nbsp;
                                                    <button type="button" className="btn btn-dark" onClick={() => generateBirthCertificatePDF(formData)}>
                                                        <i className="ri-printer-line me-1"></i>Print
                                                    </button>
                                                    {formData.cert_id && (
                                                        <>&nbsp;&nbsp;
                                                            <button type="button" className="btn btn-secondary" onClick={resetForm}>
                                                                <i className="ri-close-line me-1"></i>Cancel
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <br />

                        {/* ── List Card ── */}
                        <div className="card">
                            <div className="card-body pt-0">
                                <DataTable
                                    columns={columns}
                                    data={formData.l1}
                                    pagination
                                    highlightOnHover
                                    striped
                                    responsive
                                />
                                <div className="d-flex justify-content-end">
                                    <div className="pagination-wrap hstack gap-2">
                                        <a className="page-item pagination-prev" href="javascript:void(0)"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (formData.page_no > 0) { formData.page_no--; initData(); }
                                            }}>Previous</a>
                                        <ul className="pagination listjs-pagination mb-0"></ul>
                                        <a className="page-item pagination-next" href="javascript:void(0)"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                formData.page_no++;
                                                initData();
                                            }}>Next</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* ── Delete Confirmation Modal ── */}
            {showDeleteModal && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title text-danger">
                                    <i className="ri-delete-bin-line me-2"></i>Confirm Delete
                                </h5>
                                <button type="button" className="btn-close"
                                    onClick={() => { setShowDeleteModal(false); setDeleteTarget(null); }}>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mb-2">Are you sure you want to delete this certificate?</p>
                                <table className="table table-sm table-bordered mb-0">
                                    <tbody>
                                        <tr><th width="110">Child</th><td>{deleteTarget?.cert_child_name || "—"}</td></tr>
                                        <tr><th>Patient</th><td>{deleteTarget?.cert_patient_name || "—"}</td></tr>
                                        <tr><th>Cert No.</th><td>{deleteTarget?.cert_id || "—"}</td></tr>
                                    </tbody>
                                </table>
                                <div className="alert alert-danger mt-3 mb-0 py-2">
                                    <i className="ri-error-warning-line me-1"></i> This action cannot be undone.
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary"
                                    onClick={() => { setShowDeleteModal(false); setDeleteTarget(null); }}>
                                    Cancel
                                </button>
                                <button type="button" className="btn btn-danger" onClick={delItem}>
                                    <i className="ri-delete-bin-line me-1"></i>Yes, Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}

export default BirthCert;